<template>
    <v-card class="mb-12">
        <v-card-title class="px-8">
            <v-row>
                <v-col>
                    Brokerage Accounts
                    <h4
                        style="float: right; display: inline">  Total Value: {{ totalManagedAccount | money}}</h4>
                </v-col>
            </v-row>
<!--            <v-col sm="4" md="2" class="justify-end d-flex align-center">-->
<!--                <v-btn @click="addAccount" class="ma-1 d-flex white&#45;&#45;text" color="#1D5BE5" rounded depressed small>-->
<!--                    Add new account-->
<!--                </v-btn>-->
<!--            </v-col>-->
        </v-card-title>
        <v-data-table
            dense
            :headers="headers"
            :items="accounts"
            :items-per-page="accounts.length"
            :loading="loading"
            :mobile-breakpoint="0"
            class="account-table"
        >
            <template #body="{items}">
                <template v-for="(item, index) in items">
                    <tr :key="item.iav_account.id + index">
                        <td>
                            {{ getAccountName(item.iav_account) }}
                        </td>
                        <td>
                            {{ getAccountType(item.iav_account.type_of_account_cd) }}
                        </td>
                        <td>
                            {{ item.iav_account.company_name }}
                        </td>
                        <td>
                            {{ item.iav_account.account_number }}
                        </td>
                        <td>
                            {{ item.iav_account.value }}
                        </td>
                        <td>
                            <v-btn
                                v-if="externalAccountData(item)"
                                class="d-flex white--text" color="#1D5BE5" rounded depressed small
                                @click="item.show = !item.show"
                            >
                                <template v-if="items[index].show">Hide</template>
                                <template v-else>Show</template>
                            </v-btn>
                        </td>
                    </tr>
                    <tr v-if="externalAccountData(item)" :key="item.iav_account.id + 'positions'">
                        <td colspan="5" v-show="item.show">
                            <v-card elevation="0" color="transparent" style="padding-left: 50px;">
                                <v-simple-table class="year-position-table">
                                    <tbody>
                                    <tr>
                                        <th></th>
                                        <th>
                                            Holdings
                                        </th>
                                        <th>
                                            Units
                                        </th>
                                        <th>
                                            Price
                                        </th>
                                        <th>
                                            Cost
                                        </th>
                                        <th>
                                            Value
                                        </th>
                                        <th>
                                            Gain/Loss
                                        </th>
                                    </tr>
                                    </tbody>
                                    <tbody v-for="(positionsLoop, investmentType) in externalAccountData(item).positions" :key="'positionloop-'+investmentType">
                                    <tr>
                                        <th class="tab-subheading" colspan="8">
                                            {{ investmentType === null ? 'Other' : investmentType }}
                                        </th>
                                    </tr>
                                    <tr v-for="(position, positionIndex) in positionsLoop" :key="'position-'+positionIndex">
                                        <td class="text-left w-30">{{ position.name }} ({{ position.symbol }})</td>
                                        <td>{{ position.holding | percentage }}</td>
                                        <td>{{ position.balance }}</td>
                                        <td>{{ position.price | money }}</td>
                                        <td>{{ position.cost | money }}</td>
                                        <td>{{ position.value | money }}</td>
                                        <td>{{ position.gainLoss | money }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Totals
                                        </td>
                                        <td>
                                            <strong>{{ externalAccountData(item).sumsByCategory[investmentType].holdings | percentage }}</strong>
                                        </td>
                                        <td colspan="2"></td>
                                        <td>
                                            <strong>{{ externalAccountData(item).sumsByCategory[investmentType].costs | money }}</strong>
                                        </td>
                                        <td>
                                            <strong>{{ externalAccountData(item).sumsByCategory[investmentType].values | money }}</strong>
                                        </td>
                                        <td>
                                            <strong>{{ externalAccountData(item).sumsByCategory[investmentType].gainLosses | money }}</strong>
                                        </td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                            <v-card elevation="0">
                                <v-simple-table dark class="year-position-table-summary">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>
                                            Holdings
                                        </th>
                                        <th colspan="2"></th>
                                        <th>
                                            Cost
                                        </th>
                                        <th>
                                            Value
                                        </th>
                                        <th>
                                            Gain/Loss
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th>
                                            Totals
                                        </th>
                                        <td>
                                            100%
                                        </td>
                                        <td colspan="2"></td>
                                        <td>{{ externalAccountData(item).sums.costs | money }}</td>
                                        <td>{{ externalAccountData(item).sums.values | money }}</td>
                                        <td>{{ externalAccountData(item).sums.gainLosses | money }}</td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                        </td>
                    </tr>
                </template>

            </template>

<!--            <template v-slot:item.iav_account.individual_id="{ item }">-->
<!--                {{ getAccountName(item.iav_account) }}-->
<!--            </template>-->
<!--            <template v-slot:item.iav_account.type_of_account_cd="{ item }">-->
<!--                {{ getAccountType(item.iav_account.type_of_account_cd) }}-->
<!--            </template>-->
<!--            <template v-slot:item.iav_account.value="{ item }">-->
<!--                {{ item.iav_account.value | money }}-->
<!--            </template>-->
<!--            <template-->
<!--                v-slot:item.iav_account.deposits="{ item }">-->
<!--                {{ item.iav_account.deposits | money }}-->
<!--            </template>-->
<!--            <template-->
<!--                v-slot:item.iav_account.withdrawals="{ item }">-->
<!--                {{ item.iav_account.withdrawals | money }}-->
<!--            </template>-->
<!--            <template-->
<!--                v-slot:item.iav_account.account_start_value="{ item }">-->
<!--                {{ item.iav_account.account_start_value | money }}-->
<!--            </template>-->
<!--            <template-->
<!--                v-slot:item.iav_account.return_percentage="{ item }">-->
<!--                {{ item.iav_account.return_percentage | percentage }}-->
<!--            </template>-->
        </v-data-table>
        <brokerage-account-modal v-model="showModal" :household-id="user.household_id" :brokerageAccount="selectedBrokerageAccount" :key="selectedBrokerageAccountKey" @reload="loadAccounts" />
    </v-card>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import axios from "axios";
import BrokerageAccountModal from "@/components/accounts/BrokerageAccountModal";

export default {
    name: "BrokerageAccounts",
    components: {BrokerageAccountModal},
    props: {
        showPerformance: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            positions: state => state.household.positions,
            totalManagedAccount: state => state.accounts.totalManagedAccount,
        }),
        ...mapGetters('household', [
            'getAccountName',
        ]),
        ...mapGetters('constants', [
            'getAccountType',
        ]),
        ...mapGetters('auth', [
            'user',
        ]),
        selectedBrokerageAccountKey() {
            if (this.selectedBrokerageAccount === null) {
                return null;
            }

            return this.selectedBrokerageAccount.id;
        },
        headers() {
            let headers = [
                    { text: 'Owner', value: 'iav_account.individual_id' },
                    { text: 'Type', value: 'iav_account.type_of_account_cd' },
                    // { text: 'Open Date', value: 'iav_account.open_date' },
                    { text: 'Held At', value: 'iav_account.company_name' },
                    { text: 'Acct Number', value: 'iav_account.account_number' },
                    { text: 'Balance', value: 'iav_account.value' },
                    { text: 'Positions', value: '' },
                ];

            if (this.showPerformance) {
                headers = [
                    ...headers,
                    { text: 'Deposits', value: 'iav_account.deposits' },
                    { text: 'Withdrawals', value: 'iav_account.withdrawals' },
                    { text: 'Initial Deposits', value: 'iav_account.account_start_value' },
                    { text: 'Source of Funds', value: 'source_of_funds' },
                    { text: 'Strategy', value: 'inv_strategy' },
                    { text: 'Return', value: 'iav_account.return_percentage' },
                ]
            }

            return headers;
        },
        externalAccountData() {
            return (item) => {
                let iavAccount = item.iav_account;
                return this.positions?.enabledExternalAccounts?.find((externalAccount) => {
                    return externalAccount.account.account_number === iavAccount.account_number;
                });
            }
        }
    },
    data() {
        return {
            loading: false,
            accounts: [],
            showModal: false,
            selectedBrokerageAccount: null
        }
    },
    mounted() {
        this.loadAccounts();
        this.$store.dispatch('household/fetchPositions', this.user.household_id);
    },
    methods: {
        deleteAccount(brokerageAccount) {
            let reply = confirm('Are you sure you want to destroy this brokerage account?');

            if (!reply) {
                return false;
            }

            axios.delete('/api/households/' + this.user.household_id + '/account-manager-brokerage-accounts/' + brokerageAccount.id, { showLoader: false })
                .then(() => this.loadAccounts());
        },
        loadAccounts() {
            this.loading = true;
            axios.get('/api/households/' + this.user.household_id + '/account-manager-brokerage-accounts', { showLoader: false })
                .then(response => {
                    let accounts =  response.data.data.accountManagerBrokerageAccounts;

                    for (let i = 0; i < accounts.length; i++) {
                        accounts[i].show = false;
                    }

                    this.accounts = accounts;
                    this.loading = false;
                });
        },
        addAccount() {
            this.selectedBrokerageAccount = null;

            this.showModal = true;
        },
        editAccount(brokerageAccount) {
            let selectedBrokerageAccount = {...brokerageAccount};

            this.selectedBrokerageAccount = {...selectedBrokerageAccount.iav_account};

            this.selectedBrokerageAccount.id = selectedBrokerageAccount.id;
            this.selectedBrokerageAccount.source_of_funds = selectedBrokerageAccount.source_of_funds;
            this.selectedBrokerageAccount.inv_strategy = selectedBrokerageAccount.inv_strategy;
            this.selectedBrokerageAccount.active = selectedBrokerageAccount.active;

            this.showModal = true;
        }
    }
}
</script>

<style>

    .account-table th {
        height: 90px !important;
        color: #FFF !important;
        text-transform: uppercase;
        font-weight: 500;
        background-color: #1D5BE5;
    }

    .account-table td {
        padding: 16px !important;
        font-size: 0.8rem !important;
    }

</style>
